import React from 'react';
import { Link } from 'react-router-dom';
import { useBusinessData } from '../../context/BusinessContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as brandIcons from '@fortawesome/free-brands-svg-icons';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import '../../css/Footer.css';
import SocialMediaLinks from '../common/SocialMediaLinks';

const Footer = () => {
  const { loading, getData, hasData } = useBusinessData();
  
  // Get all social media links dynamically
  const getSocialMediaLinks = () => {
    const socialMedia = getData('contactInfo.socialMedia', {});
    return Object.entries(socialMedia)
      .filter(([key, socialData]) => 
        socialData && 
        socialData.url && 
        socialData.url.trim() !== '' && 
        socialData.url !== 'https://chat.whatsapp.com/YOUR_COMMUNITY_INVITE_LINK' &&
        (socialData.enabled !== false) // Check enabled flag (default true if undefined)
      )
      .map(([key, socialData]) => ({
        key,
        url: socialData.url,
        icon: brandIcons[socialData.icon] || solidIcons.faLink,
        label: socialData.label || key.charAt(0).toUpperCase() + key.slice(1)
      }));
  };
  
  // Get business data
  const businessName = getData('name', 'BusinessInfo');
  const foundedYear = getData('foundedYear', '2005');
  
  // Get contact info
  const address = {
    street: getData('contactInfo.address.street', '123 Business Street'),
    city: getData('contactInfo.address.city', 'Business City'),
    state: getData('contactInfo.address.state', 'BC'),
    zipCode: getData('contactInfo.address.zipCode', '12345')
  };
  
  const email = getData('contactInfo.email', 'info@businessinfo.com');
  const phone = getData('contactInfo.phone', '(123) 456-7890');
  const socialMediaLinks = getSocialMediaLinks();
  
  // Check if donation is enabled
  const isDonationEnabled = getData('donation.enabled', false);
  
  // Get footer text content
  const footerDescription = getData('ui.footer.description', 'Providing excellent business solutions since ' + foundedYear + '. We are committed to helping businesses grow and succeed.');
  const quickLinksTitle = getData('ui.footer.quickLinksTitle', 'Quick Links');
  const contactInfoTitle = getData('ui.footer.contactInfoTitle', 'Contact Info');
  const copyrightText = getData('ui.footer.copyrightText', 'All Rights Reserved.');
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h2>{businessName}</h2>
          <p>{footerDescription}</p>
        </div>
        
        <div className="footer-section">
          <h3>{quickLinksTitle}</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/vision">Vision</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            {isDonationEnabled && <li><Link to="/donate">Donate</Link></li>}
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>{contactInfoTitle}</h3>
          <p>{address.street}</p>
          <p>{address.city}, {address.state} {address.zipCode}</p>
          <p>Email: {email}</p>
          <p>Phone: {phone}</p>
          {socialMediaLinks.length > 0 && <SocialMediaLinks variant="footer" />}

        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {businessName}. {copyrightText}</p>
      </div>
    </footer>
  );
};

export default Footer; 